<template>
  <custom-dialog
    width="600px"
    :title="$t('dms_device_detail_fault_more.ckclfa')"
    :visible="visible"
    v-on="$listeners"
    appendToBody
  >
    <div class="dialog-body device-detail-fault-more">
      <div class="information-body">
        <el-row>
          <el-col :span="24">
            <div class="grid-title">{{ $t('dms_device_detail_fault_more.gu_zhang_ming_cheng') }}</div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content">{{ info.eventName || '-' }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="grid-title">{{ $t('dms_device_detail_fault_more.gu_zhang_dai_ma') }}</div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content">{{ info.eventCode || '-' }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="grid-title">{{ $t('dms_device_detail_fault_more.ji_qi_dai_ma') }}</div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content">{{ vCode }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="grid-title">{{ $t('dms_device_detail_fault_more.ke_hu_chu_li_ti_shi') }}</div>
          </el-col>
          <el-col :span="24">
            <div
              class="grid-content html-text"
              v-html="getFileText(info.customerDisposal || info.hmiDisposal)"
            ></div>
            <template v-if="hasVal(info.customerMedia)">
              <!-- 图片 -->
              <div
                class="grid-content"
                v-if="$isImage('info.customerMedia')"
              >
                <img
                  class="info-img"
                  :src="info.customerMedia"
                />
              </div>
              <!-- 视频或其他 -->
              <div
                class="grid-content"
                v-else
              >
                <t-upload
                  type="file"
                  :limit="3"
                  :bizId="info.eventId"
                  bizType="dms.disposal.customer"
                  v-model="customerMediaList"
                  :disabled="true"
                ></t-upload>
              </div>
            </template>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="grid-title">{{ $t('dms_device_detail_fault_more.shclfa') }}</div>
          </el-col>
          <el-col :span="24">
            <div
              class="grid-content html-text"
              v-html="getFileText(info.serviceDisposal)"
            ></div>
            <!-- <div class="grid-content">{{ info.serviceMedia }}</div> -->
            <template v-if="hasVal(info.serviceMedia)">
              <!-- 图片 -->
              <div
                class="grid-content"
                v-if="$isImage(info.serviceMedia)"
              >
                <img
                  class="info-img"
                  :src="info.serviceMedia"
                />
              </div>
              <!-- 视频或其他 -->
              <div
                class="grid-content"
                v-else
              >
                <t-upload
                  type="file"
                  :limit="3"
                  :bizId="info.eventId"
                  bizType="dms.disposal.technician"
                  v-model="serviceMediaList"
                  :disabled="true"
                ></t-upload>
              </div>
            </template>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="24">
            <div class="grid-title">{{$t('label_fault_serviceMedia }}</div>
          </el-col>
          <el-col :span="24">
             <file-list-download :faultId="info.faultId"></file-list-download>
          </el-col>
        </el-row> -->
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        @click="visible = false"
      >{{ $t('Common.com_close') }}</el-button>
      <!-- <el-button size="small" type="primary" @click="saveNotice">{{ $t('com_confirm')}}</el-button> -->
    </div>
  </custom-dialog>
</template>

<script>
// import apis from '@/utils/apis';
import tUpload from '@/components/upload.vue';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  components: {
    tUpload,
  },
  data() {
    return {
      info: {},
      customerMediaList: [],
      serviceMediaList: [],
    };
  },
  computed: {
    vCode() {
      const { hmiV3Code, hmiV4Code } = this.info;
      if (hmiV3Code && hmiV4Code) {
        return [hmiV3Code, hmiV4Code].join(' | ');
      }
      return hmiV4Code || '-';
    }
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.info = this.model.data;
    },
    getFileText(text) {
      if (text) {
        return `<div>${text}</div>`;
      }
      return '-';
    },
    hasVal(val) {
      return ![null, 'null', 0, false, '', undefined].includes(val);
    },
  },
};
</script>

<style lang="scss">
.device-detail-fault-more {
  .information-body {
    img {
      max-width: 100%;
    }
    .el-row {
      color: #262626;
      margin-bottom: 12px;
      line-height: 17px;
      font-size: 12px;
      > .el-col:first-child {
        font-size: 12px;
        font-weight: bold;
        color: rgba(73, 80, 87, 1);
        line-height: 28px;
      }
      > .el-col:last-child {
        font-size: 12px;
        color: rgba(108, 117, 125, 1);
        line-height: 22px;
      }
    }
    .info-img {
      width: 50%;
      height: auto;
      display: block;
    }
  }

  .html-text{
    white-space: pre-line;
  }
}
</style>
